import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'banners',
            name: 'banner',
            class: 'Modules\\Banner\\Entities\\Banner',
            autoLoadBannersHome: false,
            forms: {
                'home.main': {
                    component: 'default-banners-form',
                    alias: 'Home - Principal',
                    tableImage: 'images.small'
                },
                'categories.sales': {
                    component: 'sale-category-banners-form',
                    alias: 'Categorías con ofertas',
                    tableImage: 'images.small_profile'
                },
                'home.secondary': {
                    component: 'home-secondary-banners-form',
                    alias: 'Home - Secundario',
                    tableImage: 'images.small_profile'
                }
            }
        }
    },

    methods: {
        loadHomeBanners() {
            return this.loadIndex({
                scopes: {whereType: 'home.main'},
                paginate: 10,
                placement: 'home_main'
            })
        },

        addForm(type, component, alias, tableImage = 'images.small') {
            this.forms[type] = {
                component: component,
                alias: alias,
                tableImage: tableImage
            }

            return this
        },

        getForm(type) {
            return this.forms[type] ?? {}
        }
    },

    created() {
        if(
            this.autoLoadBannersHome &&
            this.$state.scope == 'web'
        ) {
            this.loadHomeBanners()
        }
    }
}